import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'

import { TooltipModule } from 'primeng/tooltip'

import { FlxButtonModule, FlxIconModule } from '@flowx/angular-ui-toolkit'
import { TOOLTIP_DEFAULT_DELAY } from '@flowx/designer/modules/core/dictionary/constants'

import { FlxNotificationContentComponent } from '../../notification-content/notification-content.component'
import { ExtendedNotification } from '../../notifications.model'
import { relativeAgeLabel } from '../notifications-center.model'

@Component({
  selector: 'flx-notification-center-item',
  imports: [TooltipModule, FlxButtonModule, FlxIconModule, FlxNotificationContentComponent],
  templateUrl: './notification-center-item.component.html',
  host: {
    // `group` so the mark-as-read button can reveal itself on hover of the whole row.
    'class': 'group block border-b border-neutral-100 px-6 py-2',
    '[class.bg-blue-50]': '!notification().markedRead',
    'data-testid': 'notification-center-item',
    '[attr.data-status]': 'notification().status',
    '[attr.data-read]': 'notification().markedRead',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxNotificationCenterItemComponent {
  TOOLTIP_DEFAULT_DELAY = TOOLTIP_DEFAULT_DELAY

  notification = input.required<ExtendedNotification>()
  currentTime = input.required<number>()

  markAsRead = output<void>()
  actionClicked = output<void>()

  age = computed(() => relativeAgeLabel(this.notification().createdTimestamp, this.currentTime()))
}
